"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateDepositTicketPayload = void 0;
var validateDepositTicketPayload = exports.validateDepositTicketPayload = function validateDepositTicketPayload(payload,
/**
 * "registeredFields" is supplied by redux-form.
 * It contains all <Field /> components mounted as children of the form.
 */
registeredFields) {
  return Object.keys(payload).reduce(function (acc, key) {
    if (registeredFields.hasOwnProperty(key) || key === 'ProductSymbol' || key === 'ProductId' || key === 'TemplateType') acc[key] = payload[key];
    return acc;
  }, {});
};